module.exports = __webpack_public_path__ + "img/profile-picture-used.3a643f84.svg";